/**
 * Cloudflare Turnstile gating helper (P27).
 *
 * Lives outside the widget component file so the component file only exports
 * components (react-refresh/only-export-components). The feature is gated on
 * VITE_TURNSTILE_SITE_KEY: with the key absent (default local dev state) this
 * returns null, callers render no widget and send no token.
 */

/** Site key from the build env; null (feature off) when absent or blank. */
export function getTurnstileSiteKey(): string | null {
  const key = import.meta.env.VITE_TURNSTILE_SITE_KEY;
  return key && key.trim() ? key.trim() : null;
}
